var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.5 11.35c0-.562 0-.844-.143-1.04a.8.8 0 0 0-.166-.167C21.994 10 21.712 10 21.15 10h-7.3c-.562 0-.844 0-1.04.143a.8.8 0 0 0-.167.166c-.143.197-.143.479-.143 1.041v37.3c0 .563 0 .844.143 1.04q.07.097.166.167c.197.143.479.143 1.041.143h7.3c.563 0 .844 0 1.04-.143a.8.8 0 0 0 .167-.166c.143-.197.143-.479.143-1.041zm25 0c0-.562 0-.844-.143-1.04a.8.8 0 0 0-.166-.167C46.994 10 46.712 10 46.15 10h-7.3c-.562 0-.844 0-1.04.143a.8.8 0 0 0-.167.166c-.143.197-.143.479-.143 1.041v37.3c0 .563 0 .844.143 1.04q.07.097.166.167c.197.143.479.143 1.041.143h7.3c.563 0 .844 0 1.04-.143a.8.8 0 0 0 .167-.166c.143-.197.143-.479.143-1.041z",
    clipRule: "evenodd"
  })));
};
export default SvgPause;